import { Dispatch } from 'redux';
import { saveAs } from 'file-saver';

import ENDPOINT from '../../services/endpoints';
import API from '../../services/requestService';
import { GetReportsType, GetReportsProductsType, UpdateReportForm, GetReportDetail, UpdateReportValidationObject, UpdateReportIsFetchingState, UpdateFinalReportFormData, UpdateIsExportReport, ResetReportFilter } from './actionTypes';
import { showToast, showLoader } from "./common";
import { TOAST_HEADER, MESSAGES } from '../../services/constants';
import moment from 'moment';
import { ExportType, ReportType } from '../../shared/models/reportModels';

export const getReportsType = () => async (dispatch: Dispatch<any>) => {
    dispatch(showLoader(true));

    try {
        const { data: response } = await API.get(ENDPOINT.getReportsType);
        if (response.isSuccess) {
            dispatch({ type: GetReportsType, payload: response.data })
        } else {
            dispatch(showToast(TOAST_HEADER.ERROR, response.message));
        }
    } catch (e) {
        console.error('getReportsType', e);
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
    } finally {
        dispatch(showLoader(false));
    }
}

export const getReportsProductsType = () => async (dispatch: Dispatch<any>) => {
    dispatch(showLoader(true));
    try {
        const { data: response } = await API.get(ENDPOINT.getReportsProductsType);
        if (response.isSuccess) {
            dispatch({ type: GetReportsProductsType, payload: response.data })
        } else {
            dispatch(showToast(TOAST_HEADER.ERROR, response.message));
        }
    } catch (e) {
        console.error('getProductType', e);
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
    } finally {
        dispatch(showLoader(false));
    }
}

export const updateReportForm = (reportForm: any) => (dispatch: Dispatch<any>) => {
    dispatch(updateFetchReportState(null));
    dispatch({
        type: UpdateReportForm,
        payload: reportForm
    });
}

const updateFetchReportState = (state: boolean | null) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: UpdateReportIsFetchingState,
        payload: state
    })
}

const getReportEndPointURL = (reportType: number) => {
    if (reportType === ReportType.ColumnReport) {
        return ENDPOINT.getColumnReportDetail;
    } else if (reportType === ReportType.ProductReport) {
        return ENDPOINT.getProductReportDetail;
    } else if (reportType === ReportType.RepairInProgress) {
        return ENDPOINT.getRepairInTimeReportDetail;
    } else if(reportType===ReportType.PerMonthReport){
        return ENDPOINT.getPerMonthReport;
    }else if(reportType===ReportType.PerMonthByProductTypeReport){
        return ENDPOINT.getPerMonthProducTypeReport;
    } else if(reportType===ReportType.AverageTimeInstatusDataReport){
        return ENDPOINT.getAverageTimeInstatusDataReport
    }
    return '';
}

export const getReportDetail = (params: any) => async (dispatch: Dispatch<any>) => {
    dispatch(showLoader(true));
    dispatch(updateFetchReportState(true));
    const finalParams = Object.assign({}, params);
    try {
        
        if (params.from && params.to) {
            params.from = moment(params.from).format('YYYY/MM/DD');
            params.to = moment(params.to).format('YYYY/MM/DD');
            params.to=params.to+' 23:59:59';
        
        } else {
            params.from = null;
            params.to = null;
        } 
        if (params.createdFrom && params.createdTo) {
            params.createdFrom = moment(params.createdFrom).format('YYYY/MM/DD');
            params.createdTo = moment(params.createdTo).format('YYYY/MM/DD');
            params.createdTo=params.createdTo+' 23:59:59';
        
        } else {
            params.createdFrom = null;
            params.createdTo = null;
        } 
        const { data: response } = await API.post(getReportEndPointURL(params.reportEnum), params);
        if (response.isSuccess) {
            dispatch({ type: GetReportDetail, payload: response.data });
            dispatch({type: UpdateFinalReportFormData, payload: finalParams});
        } else {
            dispatch({ type: GetReportDetail, payload: null });
            dispatch(showToast(TOAST_HEADER.ERROR, response.message));
        }
    } catch (e) {
        console.error('getReportDetail', e);
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
    } finally {
        dispatch(showLoader(false));
        dispatch(updateFetchReportState(false));
    }
}

export const updateValidationObj = (validationObj: any) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: UpdateReportValidationObject,
        payload: validationObj
    });
}

const getReportName = (reportId: number) => {
    let reportName = 'Report';
    const date = moment().format('DD/MM/YYYY');
    if (reportId === ReportType.ColumnReport) {
        reportName = 'ColumnReport';
    } else if (reportId === ReportType.ProductReport) {
        reportName = 'ProductReport';
    } else if (reportId === ReportType.RepairInProgress) {
        reportName = 'RepairInProgressReport';
    }
    else if (reportId === ReportType.PerMonthReport) {
        reportName = 'UnitsPerMonthReport';
    }

    return reportName + '_' + date;
}

export const exportReport = (params: any) => (dispatch: Dispatch<any>) => {
    return new Promise(async (resolve, reject) => {
        try {
            dispatch({
                type: UpdateIsExportReport,
                payload: true
            });
            const response = await API.post(ENDPOINT.exportReport, params, {responseType: 'arraybuffer'});
            // download file
            const blobData = new Blob([response.data], {
                type: params.exportType === ExportType.CSV
                ? response.headers ? 'text/csv' : 'text/csv'
                : response.headers ? response.headers['content-type'] : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            saveAs(
                blobData, 
                params.exportType === ExportType.CSV 
                    ? (getReportName(params.reportEnum) + '.csv') 
                    : (getReportName(params.reportEnum) + '.xlsx')
            );
            // return response
            resolve(response);
        } catch(e) {
            console.error('exportReport', e);
            dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
            reject(e);
        } finally {
            dispatch({
                type: UpdateIsExportReport,
                payload: false
            });
        }
    })
}

export const updateFinalReportForm = (params: any) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: UpdateFinalReportFormData,
        payload: params
    });
}

export const resetReportFilter = () => (dispatch: Dispatch<any>) => {
    dispatch({type: ResetReportFilter});
}